import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from "react-redux"
import { Redirect } from 'react-router-dom'
import { hoursFunctions } from '../restaurants/Hours'
import { tagFunctions } from '../restaurants/Tags'
import { updateSortOptions } from '../../store/actions/restaurantActions'

function Redirector() {

const [openList, setOpenList] = useState(false);
const [options, setOptions] = useState(false);
const [distanceList, setDistanceList] = useState(false);

const dispatch = useDispatch();

const restaurants = useSelector((state)=>state.firestore.ordered.restaurants);
const users = useSelector((state)=>state.firestore.data.users);
const userId = useSelector((state)=>state.firebase.auth.uid);
const restaurant = useSelector((state)=>state.restaurant);

useEffect(()=>{

if(!openList){
	setOpenList(hoursFunctions.compileHours(restaurants));	
}
if(!options){
	setOptions(tagFunctions.compileTags(restaurants));	
}

if( (restaurant.sortOptions === undefined || !restaurant.sortOptions.openList || !restaurant.sortOptions.options)
 && openList && options){
       //console.log('test sort options update')
       dispatch(updateSortOptions({
       	sortFavorites: false,
	    sortOnlineNotMenu: false,
	    sortOpen: false,
	    sortPickup: true,
	    sortDistance: true,
	    anyTags: true,
	    allTags: false,
	    sortTags: '',
	    openList: openList,
	    options: options,
	    allContent: '',
	    sortNames:'',
	    sortName:'',
	    sortCombined:'',
	    combinedSort:'',
	    carouselPosition:1,
	    summaryChange:false,
	    
	    httpResponse:'',
	    locationList:'',
	    locationList2:'',
	    distanceList:{},
	    distanceList2:{},
	    fullDistanceList:{},

	    doOnce:true,
	    doOnceAPI:true,
	    doOnceDistance:true,
	    prevDistanceListLength:999,
	    sliderWidth:document.body.clientWidth - 20
       }));
      } 

}
  ,[userId, users, restaurants, restaurant, openList, options])


	return(
		<>
			<div style={{margin:'auto', textAlign:'center'}}>
				<p>loading...</p>
				{!userId && <Redirect to='/signin' />}
				{
				restaurant && restaurant.sortOptions && restaurant.sortOptions.openList && restaurant.sortOptions.options &&
				<Redirect to='/newDashboard' />
				}
			</div>
		</>
	);
}

export default Redirector;